import classNames from "classnames";
import React from 'react';


import './Divider.css';


export interface DividerProps {
    withPadding?: boolean;
}

export const Divider = (
    {
        withPadding = false,
    }: DividerProps) => (
    <div className={classNames('Divider', {
        'Divider--withPadding': withPadding
    })}/>
)
